export interface GameStats {
  Great: number;
  Good: number;
  Bad: number;
  Miss: number;
}

export interface GameResult {
  score: number;
  maxCombo: number;
  stats: GameStats;
  mistakes: Record<string, number>;
  accuracy: number;
  playId?: string;
  saveStatus?: 'saving' | 'saved' | 'failed';
  previousScore?: number;
  analysis?: { scores?: Record<string, number | null> };
}

export function buildMockCoachMetrics(result: Partial<GameResult> = {}): Record<string, number> {
  const accuracy = Math.max(0, Math.min(100, result.accuracy || 84));
  const misses = Object.values(result.mistakes || {}).reduce((sum, value) => sum + value, 0);
  return {
    beatStability: Math.max(62, Math.min(96, accuracy + 4)),
    timingControl: Math.max(58, Math.min(94, accuracy - 2)),
    patternAccuracy: Math.max(55, Math.min(96, accuracy - Math.min(8, misses))),
    tempoMaintenance: Math.max(60, Math.min(95, accuracy + 1)),
    restRecovery: Math.max(56, Math.min(92, accuracy - 5)),
    limbCoordination: Math.max(58, Math.min(94, accuracy - Math.min(6, Math.ceil(misses / 2)))),
  };
}
